import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { WorkspaceProvider } from "@/context/WorkspaceContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import OtpVerify from "@/pages/OtpVerify";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Home from "@/pages/Home";
import CallsList from "@/pages/CallsList";
import CallNew from "@/pages/CallNew";
import CallDetail from "@/pages/CallDetail";
import Settings from "@/pages/Settings";
import FinanceDashboard from "@/pages/finance/Dashboard";
import RecurringJobNew from "@/pages/finance/RecurringJobNew";
import OneTimeJobNew from "@/pages/finance/OneTimeJobNew";
import MonthlyBilling from "@/pages/finance/MonthlyBilling";
import FirmBilling from "@/pages/finance/FirmBilling";
import RecurringExpenseNew from "@/pages/finance/RecurringExpenseNew";
import OneTimeExpenseNew from "@/pages/finance/OneTimeExpenseNew";
import MonthlyExpenses from "@/pages/finance/MonthlyExpenses";
import Personnel from "@/pages/finance/Personnel";
import PendingPayments from "@/pages/finance/PendingPayments";
import Firms from "@/pages/finance/Firms";
import PaymentsDue from "@/pages/finance/PaymentsDue";
import ShootSchedule from "@/pages/shoots/ShootSchedule";
import Photographers from "@/pages/shoots/Photographers";
import ShootStats from "@/pages/shoots/ShootStats";
import PublicPhotographerSchedule from "@/pages/shoots/PublicPhotographerSchedule";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WorkspaceProvider>
          <Toaster position="top-right" richColors toastOptions={{ style: { fontFamily: "Manrope, sans-serif", borderRadius: "10px" } }} />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/login/otp" element={<OtpVerify />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/public/photographer/:token" element={<PublicPhotographerSchedule />} />

            {/* Sales CRM */}
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/calls" element={<ProtectedRoute><CallsList /></ProtectedRoute>} />
            <Route path="/calls/new" element={<ProtectedRoute><CallNew /></ProtectedRoute>} />
            <Route path="/calls/:id" element={<ProtectedRoute><CallDetail /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

            {/* Finance */}
            <Route path="/finance" element={<ProtectedRoute><FinanceDashboard /></ProtectedRoute>} />
            <Route path="/finance/recurring-jobs/new" element={<ProtectedRoute><RecurringJobNew /></ProtectedRoute>} />
            <Route path="/finance/onetime-jobs/new" element={<ProtectedRoute><OneTimeJobNew /></ProtectedRoute>} />
            <Route path="/finance/monthly-billing" element={<ProtectedRoute><MonthlyBilling /></ProtectedRoute>} />
            <Route path="/finance/firm-billing" element={<ProtectedRoute><FirmBilling /></ProtectedRoute>} />
            <Route path="/finance/firms" element={<ProtectedRoute><Firms /></ProtectedRoute>} />
            <Route path="/finance/payments-due" element={<ProtectedRoute><PaymentsDue /></ProtectedRoute>} />
            <Route path="/finance/recurring-expenses/new" element={<ProtectedRoute><RecurringExpenseNew /></ProtectedRoute>} />
            <Route path="/finance/onetime-expenses/new" element={<ProtectedRoute><OneTimeExpenseNew /></ProtectedRoute>} />
            <Route path="/finance/monthly-expenses" element={<ProtectedRoute><MonthlyExpenses /></ProtectedRoute>} />
            <Route path="/finance/personnel" element={<ProtectedRoute><Personnel /></ProtectedRoute>} />
            <Route path="/finance/pending-payments" element={<ProtectedRoute><PendingPayments /></ProtectedRoute>} />

            {/* Shoots */}
            <Route path="/shoots" element={<ProtectedRoute><ShootSchedule /></ProtectedRoute>} />
            <Route path="/shoots/photographers" element={<ProtectedRoute><Photographers /></ProtectedRoute>} />
            <Route path="/shoots/stats" element={<ProtectedRoute><ShootStats /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </WorkspaceProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
